// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NUrxZ","type":"styles_type__11XxY","choices":"styles_choices__1RgHA"};